exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.ag-cell.ag-cell-not-inline-editing.ag-cell-with-height.ag-cell-last-left-pinned[data-v-25498b46] {\n  pointer-events: auto !important;\n  display: none;\n}\n", ""]);

// exports
